import React from 'react';
import Card1 from '../../assets/images/card_1.png';
import Card2 from '../../assets/images/card_2.png';
import Card3 from '../../assets/images/card_3.png';
import Card4 from '../../assets/images/card_4.png';
import Card5 from '../../assets/images/card_5.png';
import Card6 from '../../assets/images/card_6.png';
import Card7 from '../../assets/images/card_7.png';

export const cards = [
  {
    image: <img style={{ height : "10vh"}} src={ Card1 } />,
        text: 'Receba e envie documentos de forma simples por via digital',
    key: '1'
  },
  {
    image: <img style={{ height: "10vh" }} src={Card2} />,
      text: 'Converta os seus documentos em papel em documentos digitais num abrir e fechar de olhos',
    key: '2'
  },
  {
    image: <img style={{ height : "10vh"}} src={ Card3 } />,
      text: 'Saiba sempre o estado dos seus documentos e processe-os com 2 cliques',
    key: '3'
  },
  {
    image: <img style={{ height : "10vh"}} src={ Card4 } />,
      text: 'Faça a contabilização de documentos em segundos',
    key: '4'
  },
  {
    image: <img style={{ height : "10vh"}} src={ Card5 } />,
      text: 'Pesquise de forma simples por nome, cliente, número, valor, data...',
    key: '5'
  },
  {
    image: <img style={{ height : "10vh"}} src={ Card6 } />,
      text: 'Partilhe documentos com segurança e apenas com quem desejar',
    key: '6'
  },
  {
    image: <img style={{ height : "10vh"}} src={ Card7 } />,
      text: 'Tenha um sistema de organização prático e de acesso imediato às pastas de cada cliente e dos seus documentos',
    columnPosition: '2 / 3',
    marginTop: '0px',
    key: '7'
  }
];